'use client';

import { useState } from 'react';
import Link from 'next/link';

export default function ForgotPasswordPage() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth-flow/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      setSent(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ padding: '40px 24px' }}>
      <div className="w-full glass" style={{ maxWidth: 380, padding: '40px 36px' }}>
        <div style={{ marginBottom: 32 }}>
          <div className="flex items-baseline gap-2" style={{ marginBottom: 6 }}>
            <span style={{ color: '#F3F5F7', fontWeight: 700, fontSize: 22, letterSpacing: '-0.03em' }}>ATN</span>
            <span style={{ color: '#697586', fontWeight: 400, fontSize: 16 }}>Portal</span>
          </div>
          <p style={{ color: '#697586', fontSize: 13 }}>Reset your password</p>
        </div>

        {sent ? (
          <p style={{ color: '#9AA5B5', fontSize: 13, lineHeight: 1.6 }}>
            If an account exists for that email, a reset link is on its way. Check your inbox.
          </p>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#9AA5B5', marginBottom: 6, letterSpacing: '0.02em' }}>
                EMAIL
              </label>
              <input
                type="email"
                required
                autoFocus
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                className="glass-input"
              />
            </div>

            {error && <p style={{ fontSize: 13, color: '#E05A5A', margin: 0 }}>{error}</p>}

            <button type="submit" disabled={loading} className="btn-red" style={{ marginTop: 8, width: '100%' }}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <Link href="/login" style={{ display: 'block', fontSize: 12, color: '#697586', textAlign: 'center', marginTop: 20 }}>
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
